import React from "react";

import { CoveoEngineWrapper } from "../components/coveo/CoveoEngineWrapper";
import { SearchSection } from "../components/coveo/SearchSection";
import { Auth0DocsSearchBox } from "../components/Auth0DocsSearchBox";
import Breadcrumb from '../../common/components/Breadcrumb';

export const SearchPage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const initialSearchQuery = urlParams.get("q") || "";

  return (
    <div className="search">
      <div className="bg-dots page-header-dots">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Search</Breadcrumb.Item>
          </Breadcrumb>
          <div className="search-page-contents">
            <CoveoEngineWrapper fallback={<Auth0DocsSearchBox initialValue={initialSearchQuery} />}>
              <SearchSection />
            </CoveoEngineWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};
